import { useState, useEffect } from 'react';
import { FaUserCircle, FaTimes, FaPaperPlane } from 'react-icons/fa';
import { useWindowManagerContext } from '../contexts/WindowManagerContext';

const CONTACTS = [
  { id: 1, name: 'Tom', status: 'online', statusText: 'updating profile...' },
  { id: 2, name: 'Brad1995', status: 'online', statusText: 'AFK - pizza rolls in oven' },
  { id: 3, name: 'xXx_DarkAngel_xXx', status: 'away', statusText: '~*~n0 0ne gets me~*~ [Away]' },
  { id: 4, name: 'SceneKid420', status: 'online', statusText: 'editing layout css + photobucket' },
  { id: 5, name: 'iLoveEmoMusic', status: 'busy', statusText: 'Busy: burning mix cd (do not disturb)' },
  { id: 6, name: 'CoolDude2007', status: 'offline', statusText: '' },
  { id: 7, name: 'Jenny_xoxo', status: 'online', statusText: 'on sidekick - txt me if urgent' },
  { id: 8, name: 'GamerzOnly', status: 'online', statusText: 'RuneScape clan war - no trade spam' },
];

const CHAT_SEEDS = {
  Brad1995: [
    { from: 'Brad1995', text: 'yo u at pc?', time: '3:42 PM' },
    { from: 'You', text: 'yeah whats up', time: '3:42 PM' },
    { from: 'Brad1995', text: 'found an old clip on YouBoob, its dumb but funny', time: '3:43 PM' },
    { from: 'You', text: 'send it', time: '3:43 PM' },
    { from: 'Brad1995', text: 'ok hold up, 56k mode rn', time: '3:44 PM' },
    { from: 'Brad1995', text: 'here lmao: https://www.youboob.com/watch?v=dQw4w9WgXcQ', time: '3:44 PM' },
  ],
  Tom: [
    { from: 'Tom', text: 'Thanks for joining FaceLeak.', time: '2:15 PM' },
    { from: 'Tom', text: 'Please complete your profile and upload a song.', time: '2:16 PM' },
  ],
  xXx_DarkAngel_xXx: [
    { from: 'xXx_DarkAngel_xXx', text: 'u there?', time: '8:02 PM' },
    { from: 'xXx_DarkAngel_xXx', text: 'nm just listening to Senses Fail on repeat', time: '8:03 PM' },
  ],
  SceneKid420: [
    { from: 'SceneKid420', text: 'check my new glitter layout!!', time: '6:11 PM' },
    { from: 'SceneKid420', text: 'my top 8 got DRAMA tonight', time: '6:12 PM' },
  ],
  iLoveEmoMusic: [
    { from: 'iLoveEmoMusic', text: 'new mcr interview dropped', time: '9:26 PM' },
    { from: 'iLoveEmoMusic', text: 'brb rewriting my away message again', time: '9:27 PM' },
  ],
  CoolDude2007: [
    { from: 'System', text: 'This contact is offline.', time: '12:01 PM' },
  ],
  Jenny_xoxo: [
    { from: 'Jenny_xoxo', text: 'u going to mall friday?', time: '4:50 PM' },
    { from: 'Jenny_xoxo', text: 'i need new flip phone pics lol', time: '4:50 PM' },
  ],
  GamerzOnly: [
    { from: 'GamerzOnly', text: 'cant talk long, in varrock bank', time: '7:31 PM' },
    { from: 'GamerzOnly', text: 'if u have rune scim hit me', time: '7:32 PM' },
  ],
};

const CONTACT_REPLY_BANKS = {
  Brad1995: [
    'lol',
    'brb mom yelling',
    'ok this one is NOT a rickroll',
    'u clicked right?',
    'haha gotem',
    'wait wait try this link instead',
    'my bad wrong tab',
    'rofl',
  ],
  Tom: [
    'Profile changes saved.',
    'Try adding more interests.',
    'Remember to rank your friends.',
    'New feature coming soon.',
    'Thanks for your feedback.',
  ],
  xXx_DarkAngel_xXx: [
    'k',
    'idk...',
    'whatever',
    'life = static',
    'brb eyeliner',
    '...fine',
  ],
  SceneKid420: [
    'omg yes',
    'rawr',
    'comment me back',
    'rate my pics 1-10',
    'myspace is being weird again',
    'photobucket ate my banner :(',
  ],
  iLoveEmoMusic: [
    'same',
    'that lyric hurts in a good way',
    'im burning a new mix cd rn',
    'pure volume is lagging',
    'that song is basically my away message',
  ],
  CoolDude2007: ['This user is offline.'],
  Jenny_xoxo: [
    'k',
    'ya maybe',
    'call me after 9',
    'ttyl',
    'my minutes are low lol',
    'im on my sidekick rn',
  ],
  GamerzOnly: [
    '1 sec pking',
    'lagggg',
    'meet world 82',
    'need gp fast',
    'cant type, fight',
    'brb duel arena',
  ],
};

const CONTACT_DELAYS = {
  Brad1995: [900, 2200],
  Tom: [600, 1400],
  xXx_DarkAngel_xXx: [1700, 3200],
  SceneKid420: [1100, 2600],
  iLoveEmoMusic: [1400, 2900],
  CoolDude2007: [500, 900],
  Jenny_xoxo: [900, 1900],
  GamerzOnly: [700, 1300],
};

const NUDGE_MESSAGES = [
  'Brad1995 has sent you a NUDGE.',
  'xXx_DarkAngel_xXx wants your attention.',
  'SceneKid420 sent a custom wink.',
  'GamerzOnly sent a NUDGE.',
];

const getNowTime = () =>
  new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

const pickFrom = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const MSNMessenger = ({ playSound }) => {
  const { openWindow } = useWindowManagerContext();
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState(CHAT_SEEDS.Brad1995);
  const [newMessage, setNewMessage] = useState('');
  const [notification, setNotification] = useState(null);
  const [typingUser, setTypingUser] = useState(null);
  const [lastReplyByContact, setLastReplyByContact] = useState({});
  const [bradRickrollCount, setBradRickrollCount] = useState(1);

  // Random notifications
  useEffect(() => {
    const interval = setInterval(() => {
      if (Math.random() > 0.7) {
        const randomContact = CONTACTS.filter((c) => c.status === 'online')[
          Math.floor(Math.random() * CONTACTS.filter((c) => c.status === 'online').length)
        ];
        if (randomContact) {
          setNotification(`${randomContact.name} has just signed in.`);
          playSound('msn', 0.4);
          setTimeout(() => setNotification(null), 3000);
        }
      }
    }, 8000);
    return () => clearInterval(interval);
  }, [playSound]);

  useEffect(() => {
    if (activeChat) {
      setMessages(CHAT_SEEDS[activeChat] || []);
    }
  }, [activeChat]);

  // Simulate typing
  useEffect(() => {
    if (activeChat) {
      const typingInterval = setInterval(() => {
        const typeChance =
          activeChat === 'Tom' ? 0.45 : activeChat === 'GamerzOnly' ? 0.7 : 0.58;
        if (Math.random() > typeChance) {
          setTypingUser(activeChat);
          const ms = activeChat === 'Tom' ? 1100 : 1800 + Math.random() * 1200;
          setTimeout(() => setTypingUser(null), ms);
        }
      }, 5000);
      return () => clearInterval(typingInterval);
    }
  }, [activeChat]);

  const pickNonRepeatingReply = (contactName, replies) => {
    const last = lastReplyByContact[contactName];
    const options = replies.filter((r) => r !== last);
    const chosen = pickFrom(options.length ? options : replies);
    setLastReplyByContact((prev) => ({ ...prev, [contactName]: chosen }));
    return chosen;
  };

  const getContextReply = (contactName, userText) => {
    const text = userText.toLowerCase();

    if (contactName === 'Brad1995') {
      if (text.includes('link') || text.includes('video')) {
        if (bradRickrollCount === 0) {
          setBradRickrollCount(1);
          const bait = [
            'aight this is the one: https://www.youboob.com/watch?v=dQw4w9WgXcQ',
            'yo found it: https://www.youboob.com/watch?v=dQw4w9WgXcQ',
            'haha watch this first: https://www.youboob.com/watch?v=dQw4w9WgXcQ',
          ];
          return pickNonRepeatingReply(contactName, bait);
        }
        return pickNonRepeatingReply(contactName, [
          'i already sent it scroll up lol',
          'bro ur chat history is right there',
          'hold on lemme find another one',
        ]);
      }
      if (text.includes('rickroll')) {
        return pickNonRepeatingReply(contactName, [
          'who me?? never',
          'ok maybe a little',
          'classic internet law, had to do it',
        ]);
      }
    }

    if (
      contactName === 'GamerzOnly' &&
      (text.includes('rune') || text.includes('gold') || text.includes('gp'))
    ) {
      return pickNonRepeatingReply(contactName, [
        'sellin rune set cheap',
        'need 20k gp asap',
        'meet fally west bank',
      ]);
    }

    if (
      contactName === 'SceneKid420' &&
      (text.includes('layout') || text.includes('profile'))
    ) {
      return pickNonRepeatingReply(contactName, [
        'my css is broken again',
        'i changed cursor to sparkles',
        'top 8 drama > homework',
      ]);
    }

    if (contactName === 'Tom') {
      if (text.includes('help')) return 'Try the Help link at the top of FaceLeak.';
      if (text.includes('bug')) return 'Issue noted. Thank you.';
    }

    return pickNonRepeatingReply(contactName, CONTACT_REPLY_BANKS[contactName] || ['k']);
  };

  const extractVideoIdFromUrl = (rawUrl) => {
    try {
      const normalized = rawUrl.startsWith('http') ? rawUrl : `https://${rawUrl}`;
      const url = new URL(normalized);
      if (!url.hostname.includes('youboob.com')) return null;
      return url.searchParams.get('v');
    } catch {
      return null;
    }
  };

  const handleChatLinkClick = (e, rawUrl) => {
    e.preventDefault();
    const videoId = extractVideoIdFromUrl(rawUrl);
    if (videoId) {
      openWindow?.('ie', {
        url: 'youtoob',
        pageTitle: 'YouBoob',
        youToobVideoId: videoId,
        youToobAutoplay: true,
      });
      return;
    }

    openWindow?.('ie', { url: 'youtoob', pageTitle: 'YouBoob' });
  };

  const renderMessageText = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
    const parts = text.split(urlPattern);

    return parts.map((part, idx) => {
      if (part.match(urlPattern)) {
        return (
          <a
            key={`${part}-${idx}`}
            href={part.startsWith('http') ? part : `https://${part}`}
            onClick={(e) => handleChatLinkClick(e, part)}
            className="ie-link"
          >
            {part}
          </a>
        );
      }

      return <span key={`${part}-${idx}`}>{part}</span>;
    });
  };

  const sendMessage = () => {
    if (!newMessage.trim()) return;
    if (!activeChat) return;

    playSound('click', 0.2);

    const userMessage = newMessage.trim();
    const newMsg = {
      from: 'You',
      text: userMessage,
      time: getNowTime(),
    };
    setMessages((prev) => [...prev, newMsg]);
    setNewMessage('');

    const [minDelay, maxDelay] = CONTACT_DELAYS[activeChat] || [1200, 2600];
    const delay = minDelay + Math.random() * (maxDelay - minDelay);

    setTimeout(() => {
      const autoReply = {
        from: activeChat,
        text: getContextReply(activeChat, userMessage),
        time: getNowTime(),
      };
      setMessages((prev) => [...prev, autoReply]);
      playSound('msn', 0.3);

      // Occasional quick follow-up from talkative contacts to feel less scripted.
      const followUpChance =
        activeChat === 'Brad1995'
          ? 0.4
          : activeChat === 'SceneKid420'
            ? 0.3
            : activeChat === 'GamerzOnly'
              ? 0.22
              : 0.12;
      if (Math.random() < followUpChance) {
        setTimeout(() => {
          const followUp = {
            from: activeChat,
            text: getContextReply(activeChat, 'followup'),
            time: getNowTime(),
          };
          setMessages((prev) => [...prev, followUp]);
          playSound('msn', 0.25);
        }, 650 + Math.random() * 1000);
      }
    }, delay);
  };

  const sendNudge = () => {
    playSound('error', 0.5);
    const nudgeMsg = {
      from: 'System',
      text: NUDGE_MESSAGES[Math.floor(Math.random() * NUDGE_MESSAGES.length)],
      time: getNowTime(),
      isNudge: true,
    };
    setMessages((prev) => [...prev, nudgeMsg]);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'online':
        return '#00B900';
      case 'away':
        return '#FFA500';
      case 'busy':
        return '#FF0000';
      default:
        return '#808080';
    }
  };

  return (
    <div className="msn-messenger" data-testid="msn-messenger">
      {/* Notification popup */}
      {notification && (
        <div className="msn-notification" data-testid="msn-notification">
          <div className="notification-icon">USER</div>
          <div className="notification-text">{notification}</div>
        </div>
      )}

      {/* Header */}
      <div className="msn-header">
        <div className="msn-user">
          <FaUserCircle size={32} color="#00A2ED" />
          <div className="user-info">
            <span className="username">You</span>
            <span className="status-text">back in 10 mins - dont nudge</span>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="msn-content">
        {!activeChat ? (
          // Contact list
          <div className="contact-list">
            <div className="contact-group">
              <div className="group-header">
                Online ({CONTACTS.filter((c) => c.status !== 'offline').length})
              </div>
              {CONTACTS.filter((c) => c.status !== 'offline').map((contact) => (
                <div
                  key={contact.id}
                  className="contact-item"
                  onClick={() => setActiveChat(contact.name)}
                  data-testid={`contact-${contact.id}`}
                >
                  <div className="contact-avatar">
                    <FaUserCircle size={24} color="#666" />
                    <div
                      className="status-dot"
                      style={{ backgroundColor: getStatusColor(contact.status) }}
                    />
                  </div>
                  <div className="contact-info">
                    <span className="contact-name">{contact.name}</span>
                    <span className="contact-status">{contact.statusText}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="contact-group">
              <div className="group-header">Offline (1)</div>
              {CONTACTS.filter((c) => c.status === 'offline').map((contact) => (
                <div key={contact.id} className="contact-item offline">
                  <div className="contact-avatar">
                    <FaUserCircle size={24} color="#999" />
                  </div>
                  <div className="contact-info">
                    <span className="contact-name">{contact.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          // Chat window
          <div className="chat-window">
            <div className="chat-header">
              <span>{activeChat}</span>
              <button onClick={() => setActiveChat(null)} className="close-chat">
                <FaTimes size={12} />
              </button>
            </div>
            <div className="chat-messages">
              {messages.map((msg, i) => (
                <div
                  key={i}
                  className={`message ${msg.from === 'You' ? 'sent' : 'received'} ${msg.isNudge ? 'nudge' : ''}`}
                >
                  <span className="msg-sender">{msg.from}:</span>
                  <span className="msg-text">{renderMessageText(msg.text)}</span>
                  <span className="msg-time">{msg.time}</span>
                </div>
              ))}
              {typingUser && <div className="typing-indicator">{typingUser} is typing...</div>}
            </div>
            <div className="chat-input">
              <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                placeholder="Type a message..."
                data-testid="chat-input"
              />
              <button onClick={sendNudge} className="nudge-btn" title="Send Nudge">
                Nudge
              </button>
              <button onClick={sendMessage} className="send-btn" data-testid="send-message">
                <FaPaperPlane size={14} />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="msn-footer">
        <span>MSN Misdemeanor® — A Microshaft™ Surveillance Product</span>
      </div>
    </div>
  );
};

export default MSNMessenger;
